import { render, staticRenderFns } from "./BaseInputFloatinglabel.vue?vue&type=template&id=2f8c8219"
import script from "./BaseInputFloatinglabel.vue?vue&type=script&lang=js"
export * from "./BaseInputFloatinglabel.vue?vue&type=script&lang=js"
import style0 from "./BaseInputFloatinglabel.vue?vue&type=style&index=0&id=2f8c8219&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports